import strings from 'owa-strings/owa-mini-common-strings';
import { DEFAULT_OUTLOOK_THEME_COLOR } from 'mini-theme';

/**
 * These are the default 9 primary colors for users to pick from without picking their own custom hex values
 * Using Map to preserve order
 */
const defaultPrimaryColorsMap = new Map([
    [DEFAULT_OUTLOOK_THEME_COLOR, () => strings.blueCalendarColorText], // blue
    ['#498205', () => strings.greenCalendarColorText], // Green
    ['#C50F1F', () => strings.redCalendarColorText], // Red
    ['#003966', () => strings.navyCalendarColorText], // Navy
    ['#69797E', () => strings.grayCalendarColorText], // Gray
    ['#038387', () => strings.tealCalendarColorText], // Teal
    ['#E3008C', () => strings.magentaCalendarColorText], // Magenta
    ['#DA3B01', () => strings.orangeCalendarColorText], // Orange
    ['#744DA9', () => strings.violetCalendarColorText], // Violet
]);

export const defaultPrimaryColors = Array.from(defaultPrimaryColorsMap.keys());

export function getPrimaryColorName(color: string): string {
    return defaultPrimaryColorsMap[color] ? defaultPrimaryColorsMap[color]() : color;
}

// Order of color schemes that should be followed for various use cases (This is same order as Big OWA)
export const getOrderedDefaultPrimaryColors = () =>
    [0, 5, 1, 3, 8, 6, 7, 2, 4].map(index => defaultPrimaryColors[index]);
